import { render } from "./QuizPassed.vue?vue&type=template&id=b1bfd726&ts=true"
import script from "./QuizPassed.vue?vue&type=script&lang=ts"
export * from "./QuizPassed.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__